import AnchorDialog from '@base/components/src/AnchorDialog';
import Link from '@base/components/src/Link';
import currencyFormatting from '@package/utils/src/currencyFormatting';
import { MouseEventHandler } from 'react';
import clsx from 'clsx';
import styles from './ProductCardName.module.css';
import { ProductCardNameProps } from './types';

const ProductCardName = ({ product, layout, isReviewOrderPage, isShippingOptionPage }: ProductCardNameProps) =>
  product.serviceInfo ? (
    <AnchorDialog
      disableBackdropClick
      contentClassName={styles.dialogContainer}
      anchorContent={(open: MouseEventHandler<HTMLDivElement> | undefined) => (
        <div data-testid="product-name" onClick={open}>
          <p
            className={clsx(styles.productName, {
              [styles.orderDetailsProductName]: layout === 'order-details',
              [styles.orderDetailsProductNameReview]: isReviewOrderPage || isShippingOptionPage,
            })}
          >
            {product.name}
          </p>
        </div>
      )}
    >
      <div>
        <p
          className={clsx(styles.productName, {
            [styles.orderDetailsProductName]: layout === 'order-details',
            [styles.orderDetailsProductNameReview]: isReviewOrderPage || isShippingOptionPage,
          })}
        >
          {product.serviceInfo?.price
            ? `${product.serviceInfo.name} | ${currencyFormatting(product.serviceInfo.price)}`
            : product.serviceInfo?.name}
        </p>
        {product.serviceInfo.largeImage && (
          <img className={styles.largeImage} src={product.serviceInfo.largeImage} alt={product.serviceInfo.name} />
        )}
        <div dangerouslySetInnerHTML={{ __html: product.serviceInfo.desc }} />
      </div>
    </AnchorDialog>
  ) : (
    <Link data-testid="product-name-link" href={product.productUrl}>
      <p
        className={clsx(styles.productName, {
          [styles.orderDetailsProductName]: layout === 'order-details',
          [styles.orderDetailsProductNameReview]: isReviewOrderPage || isShippingOptionPage,
        })}
      >
        {product.name}
      </p>
    </Link>
  );

export default ProductCardName;
